import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat'
})
export class PhoneNumberFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return value;
    }
    if (value.startsWith('+') && value.length > 10) {
      const countryCodeEndIndex = value.indexOf(' ') > -1 ? value.indexOf(' ') : 3;
      const countryCode = value.substr(0, countryCodeEndIndex);
      const restOfNumber = value.substr(countryCodeEndIndex).replace(/\D/g, '');

      if (restOfNumber.length === 10) {
        return `${countryCode} ${restOfNumber.substr(0, 3)}-${restOfNumber.substr(3, 3)}-${restOfNumber.substr(6)}`;
      } else {
        return value;
      }
    }
    if (value.length === 10 && !isNaN(+value)) {
      return `${value.substr(0, 3)}-${value.substr(3, 3)}-${value.substr(6)}`;
    }

    if (value.length > 11) {
      const cleanedValue = value.replace(/\D/g, '');

      if (cleanedValue.length >= 10) {
        let countryCode = '';
        let phoneNumber = cleanedValue;

        if (cleanedValue.length > 10) {
          countryCode = cleanedValue.substr(0, cleanedValue.length - 10);
          phoneNumber = cleanedValue.substr(cleanedValue.length - 10);
        }

        return `${countryCode} ${phoneNumber.substr(0, 3)}-${phoneNumber.substr(3, 3)}-${phoneNumber.substr(6)}`;
      }
    }
    return value;
  }

}
